import { render, staticRenderFns } from "./EditorPageContent.vue?vue&type=template&id=2505c908&"
import script from "./EditorPageContent.vue?vue&type=script&lang=js&"
export * from "./EditorPageContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports